import { useEffect, useState } from "react"
import { Status } from "../day/dayView"
import { UserCustomerMatrixDTO } from "../../DTO/UserCustomerMatrixDTO"
import Spinner from "../../../components/Spinner/Spinner"
import { Box, Link, Tooltip } from "@mui/material"

const ellipsisCell = {
  border: '1px solid grey',
  padding: 4,
  maxWidth: 180,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap' as const,
}

const numberCell = {
  border: '1px solid grey',
  padding: 4,
  textAlign: 'right' as const,
}

export default function UserCustomerMatrix() {
  const [status, setStatus] = useState(Status.loading)
  const [ucm] = useState(new UserCustomerMatrixDTO())
  useEffect(() => {
    ucm.getFromServer().then(() => {
      setStatus(Status.standard)
    })
  }, [ucm])
  if (status === Status.loading) { return <Spinner /> }
  return <Box
    sx={{
      padding: 2,
      backgroundColor: 'white',
    }}
  >
    <Box>-- Prototyp --</Box>
    <table
    style={{
      backgroundColor: 'white',
      width: '100%',
      borderCollapse: 'collapse',
    }}
  >
    <tbody>
    
      <tr>
        <th></th>
        <th style={{textAlign: 'left'}}>Ort</th>
        <th title="Veranstaltungen">VA</th>
        <th title="Veranstaltungen der Mitarbeiter">MA-VA</th>
        <th title="Mitarbeiter">MA</th>
        {
          ucm.users.map((u) => {
            return <th
              key={`ucm-header-${u.userId}`}
              style={{
                maxWidth: 120,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              <Tooltip title={u.userName}>
                <span>{u.userName}</span>
              </Tooltip>
            </th>
          })
        }
      </tr>
      {
        ucm.customers.map((c) => {
          return <tr key={`ucm-row-${c.id}`}>
            <td style={ellipsisCell}>
              <Tooltip title={c.name}>
                <Link
                  href={`/view=spCustomerEdit/id=${c.id}`}
                  sx={{
                    display: 'block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                >{c.name}</Link>
              </Tooltip>
            </td>
            <td
              style={{
                border: '1px solid grey',
                padding: 4,
              }}
            >{c.town || ''}</td>
            <td style={numberCell}>{c.eventCount || 0}</td>
            <td style={numberCell}>{c.personEventCount || 0}</td>
            <td style={numberCell}>{c.personCount || 0}</td>
            {
              ucm.users.map((u) => {
                const match = ucm.userInCustomer(u.userId, c.id)
                return <td
                  key={`ucm-cell-${u.userId}-${c.id}`}
                  style={{
                    backgroundColor: match ? 'green' : 'white',
                    border: '1px solid grey',
                    color: 'white',
                    textAlign: 'center',
                  }}
                >{match ? 'X' : ''}</td>
              })
            }
          </tr>
        })
      }

    </tbody>
  </table>
</Box>
}
